module.exports = __webpack_public_path__ + "img/08.c7b012a9.png";